module.exports = "/shifts/components/calendarNotesComponent-5f09dd.html";